import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationOntologies from '@/modules/configurationModule/shared/components/configuration-ontologies/configuration-ontologies.vue'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { GridUtils } from '@/shared/util/grid-utils'
import { configurationSynopticTemplateOntologyService } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template-ontology/configuration-synoptic-template-ontology.service'
import { ConfigurationOntologiesState } from '@/modules/configurationModule/shared/components/configuration-ontologies/configuration-ontologies.model'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { ConfigurationSynopticTemplateResponse } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'
import {
    ConfigurationTemplatesSynopticTemplatesModalOntologiesState,
    initialConfigurationTemplatesSynopticTemplatesModalOntologiesState
} from '@/modules/configurationModule/detail/templates/synoptic-templates/components/modal-ontologies/configuration-templates-synoptic-templates-modal-ontologies.model'
import {
    ConfigurationSynopticTemplateOntologyCreateRequest,
    ConfigurationSynopticTemplateOntologyResponse
} from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template-ontology/configuration-synoptic-template-ontology.dto'

@Component({
    components: {
        ConfigurationOntologies
    }
})
export default class ConfigurationTemplatesSynopticTemplatesModalOntologies extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly synopticTemplate!: ConfigurationSynopticTemplateResponse

    state: ConfigurationTemplatesSynopticTemplatesModalOntologiesState
    constructor() {
        super()
        this.state = initialConfigurationTemplatesSynopticTemplatesModalOntologiesState()
    }

    private async _loadOntologies(): Promise<void> {
        const ontologies = await this._getOntologies()
        this.state.ontologies = ontologies.map(ontology => ({
            id: ontology.id,
            sampleType: ontology.sampleType,
            topographicCode: ontology.topographicCode,
            mostLikelyMorphologicCode: ontology.mostLikelyMorphologicCode,
            procedure: ontology.procedure,
            synopticTemplateId: ontology.synopticTemplate.id
        }))
    }

    async mounted(): Promise<void> {
        await this._loadOntologies()
    }

    /// SERVICES CALLS ///

    private async _createOntology(createRequest: ConfigurationSynopticTemplateOntologyCreateRequest): Promise<ConfigurationSynopticTemplateOntologyResponse | null> {
        const response =
            await this.$_toCallUnique(
                configurationSynopticTemplateOntologyService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
        }
        return response
    }

    private async _getOntologies(): Promise<ConfigurationSynopticTemplateOntologyResponse[]> {
        const filterModel: CommonFilterModel = {
            'synopticTemplate.id': GridUtils.getNumberFilterModel('equals', this.synopticTemplate.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response =
            await this.$_toCallUnique(
                configurationSynopticTemplateOntologyService.paginator(filterModel, params, this.state.laboratoryId))
        return response?.content ?? []
    }

    private async _deleteOntology(synopticTemplatesOntologyId: number): Promise<boolean> {
        const response =
            await this.$_toCallUnique(
                configurationSynopticTemplateOntologyService.delete(this.state.laboratoryId, synopticTemplatesOntologyId))
        if (response != null) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
        return response != null
    }

    /// FORM OPERATIONS ///

    async createOperation(state: ConfigurationOntologiesState): Promise<void> {
        const createRequest: ConfigurationSynopticTemplateOntologyCreateRequest = {
            synopticTemplateId: this.synopticTemplate.id,
            sampleTypeId: state.sampleType!.id,
            mostLikelyMorphologicCodeId: state.mostLikelyMorphologicCode?.id,
            procedureId: state.procedure?.id,
            topographicCodeId: state.topographicCode?.id
        }
        if (await this._createOntology(createRequest)) {
            await this._loadOntologies()
        }
    }

    async deleteOperation(synopticTemplatesOntologyId: number): Promise<void> {
        if (await this._deleteOntology(synopticTemplatesOntologyId)) {
            await this._loadOntologies()
        }
    }
}
